import { Button } from '@curology/ui-components-web/react/Button';
import React from 'react';
import { useFormStatus } from 'react-dom';

const SubmitButton = ({ children }: { children: React.ReactNode }) => {
  const { pending } = useFormStatus();
  return (
    <Button
      type="submit"
      className="cur-min-w-[300px]"
      loading={pending}
      disabled={pending}
    >
      {children}
    </Button>
  );
};

export default SubmitButton;
